import type {MaterialNode} from "#material/nodes/base/material/material-node"
import {materialNodeSchema} from "#material/nodes/base/material/schema"
import type {MaterialMaterialSlot} from "#material/nodes/base/material/types/io"
import {z} from "zod/v4-mini"
import type {ShaderNode} from "#material/nodes/base/material/validation/shader-node"
import {materialClosureOutput} from "#material/nodes/base/material/validation/io"
import type {MaterialNodeSockets} from "#material/types/material-node-sockets"
import type {MaterialNodeDefinition} from "#material/nodes/base/material/types/definition"
import {ExchangeNodeName} from "#material/exchange/node-name"
import {materialUiSchema} from "#material/nodes/base/material/validation/ui"

export type MaterialFrameReturns =
    | {
          output: MaterialMaterialSlot
      }
    | ShaderNode

export type MaterialFrameParameters = {
    name?: string
    labelSize?: number
    nodes: MaterialNode<any>[]
    shrink?: boolean
    text?: string
}

export interface MaterialFrameSockets extends MaterialNodeSockets {
    inputs: {}
    settings: {
        shrink: "boolean" // found in inputs: -; found in settings: bool; inferred from data: boolean
    }
    outputs: {}
}

export const materialFrameDefinition = {
    exchangeFormat: {
        nodeName: ExchangeNodeName.NodeFrame,
    },
    nodeClass: "MaterialFrame",
    ui: {
        label: "Frame",
        color: "#4987af",
        items: [],
        support: {
            cycles: false,
            three: false,
        },
    },
    validation: {
        returns: z.strictObject({output: materialClosureOutput}),
        parameters: z.strictObject({
            inputs: z.strictObject({}),
            settings: z.strictObject({
                name: z.optional(z.string()),
                labelSize: z.optional(z.number()),
                shrink: z.optional(z.boolean()),
                nodes: z.optional(z.array(materialNodeSchema)),
                text: z.optional(z.string()),
            }),
            ui: materialUiSchema,
        }),
    },
} satisfies MaterialNodeDefinition<MaterialFrameSockets>
